/** Game configuration constants. */

/** Grid dimensions for the maze. */
export const TILE_SIZE = 1.0       // World units per tile
export const WALL_HEIGHT = 1.5     // Height of maze walls

/** Character movement. */
export const MOVE_SPEED = 4.0      // Tiles per second
export const POWER_UP_DURATION = 8 // Seconds
export const POWER_UP_SPEED_MULT = 1.2

/** Enemy AI. */
export const ENEMY_SPEED = 3.5     // Tiles per second (normal)
export const ENEMY_FRIGHTENED_SPEED = 2.0
export const SCATTER_DURATION = 7  // Seconds
export const CHASE_DURATION = 20   // Seconds

/** Scoring. */
export const DOT_POINTS = 10
export const POWER_PELLET_POINTS = 50
export const GHOST_POINTS_BASE = 200 // Doubles per consecutive capture

/** Lives. */
export const STARTING_LIVES = 3
export const EXTRA_LIFE_SCORE = 10000

/** Jelly economy. */
export const JELLY_PER_CAPTURE = 25
export const JELLY_PER_LEVEL_CLEAR = 100
